import { render, staticRenderFns } from "./color-pop.vue?vue&type=template&id=3306f358&scoped=true&"
import script from "./color-pop.vue?vue&type=script&lang=js&"
export * from "./color-pop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3306f358",
  null
  
)

export default component.exports